import { render, staticRenderFns } from "./headerView.vue?vue&type=template&id=45e4c63d&scoped=true"
import script from "./headerView.vue?vue&type=script&lang=js"
export * from "./headerView.vue?vue&type=script&lang=js"
import style0 from "./headerView.vue?vue&type=style&index=0&id=45e4c63d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4c63d",
  null
  
)

export default component.exports